<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Damage from "./damage.vue";
import Scrap from "./scrap.vue";
import Warehousing from "./warehousing.vue";
import JSZip from "jszip";
import FileSaver from "file-saver";
import config from "@/utils/config";
import checkDeskShow from "./checkDeskShow.vue";
import addEmptycode from "./addEmptycode.vue";

export default {
  extends: baseList,
  components: {
    Damage,
    Warehousing,
    Scrap,
    checkDeskShow,
    addEmptycode,
  },
  data() {
    return {
      table: {
        mname: "device",
        key: "id",
        url: {
          del: "/admin/system/facility",
        },
        output: false,
        order: "updateTime",
        qrCode: "qrCode",
      },
      menus: [
        {
          label: "使用中",
          name: "deviceretrieval_list",
          auth: "system/deviceretrieval/index",
          badge: { mname: "decicestate", scene: "2" },
        },
        {
          label: "库存中",
          name: "device_list",
          auth: "system/device/index",
          badge: { mname: "decicestate", scene: "1" },
        },

        {
          label: "已损坏",
          name: "devicedamage_list",
          auth: "system/devicedamage/index",
          badge: { mname: "decicestate", scene: "3" },
        },
        {
          label: "已报废",
          name: "devicescrap_list",
          auth: "system/devicescrap/index",
          badge: { mname: "decicestate", scene: "4" },
        },
        // {
        //   label: "备用库",
        //   name: "devicestandby_list",
        //   auth: "system/devicestandby/index",
        //   badge: { mname: "decicestate", scene: "5" },
        // },
        {
          label: "空码库",
          name: "Emptycode_list",
          auth: "",
          badge: { mname: "decicestate", scene: "6" },
        },
      ],
      query: {
        state: 6,
      },
      actions: [
        {
          label: "新增空码",
          icon: "md-add",
          onClick: this.addEmptyCode,
          auth: "",
          type: "info",
        },
        {
          label: "导出标签",
          icon: "md-cloud-download",
          type: "info",
          onClick: this.downloadCodeImg,
          auth: "system/deviceretrieval/downloadCodeImg",
        },
        {
          label: "批量同步二维码",
          icon: "ios-cloud-done-outline",
          onClick: this.torefall,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "资产编号",
          key: "assetNum",
          minWidth: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "二维码",
          minWidth: 80,
          align: "center",
          key: "qrCode",
          viewimage: true,
        },
        {
          title: "操作",
          align: "center",
          width: 230,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/deviceretrieval/ref" },
              ];
              return (
                // <Button
                //   {...{ directives }}
                //   size="small"
                //   onClick={() => this.tocheckout(currentRow)}
                //   type="default"
                //   style={{
                //     border: "none",
                //     color: "#4991ff",
                //   }}
                // >
                //   编辑
                // </Button>
                <div>
                  <Button
                    {...{ directives }}
                    size="small"
                    onClick={() => this.toref(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginLeft: "5px",
                    }}
                  >
                    同步
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
      CheckDeskList: [],
    };
  },
  created() {},
  methods: {
    onClose() {
      this.search();
    },
    addEmptyCode() {
      this.$Modal.success({
        closable: true,
        title: "新增空码",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <addEmptycode vOn:closeFun={() => this.onClose()} />
            </div>
          );
        },
      });
    },
    toref(currentRow) {
      this.id = currentRow.id;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/facility/refresh/${this.id}`)
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("同步成功");
            setTimeout(() => {
              $utils.url.go(0);
            }, 300);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    loadIMage(image) {
      return new Promise(function (resolve, reject) {
        try {
          image.onload = function () {
            resolve();
          };
        } catch (e) {
          reject();
        }
      });
    },
    async downloadCodeImg() {
      if (this.arrys == null) $utils.toast.warn("请选择需要导出标签");
      // this.msg('请选择数据')
      const arry = this.arrys;
      for (var j = 0; j < arry.length; j++) {
        if (arry[j].indexOf("http") === -1) {
          arry[j] = config.IMAGE_HOST + arry[j];
        }
      }
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let date = nowDate.getDate();
      var blogTitle = "资产二维码标签" + year + month + date;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ['http://weixiu.kafukeji.com/admin/profile/upload/code/GK21112200028.png', ];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ['图片1', '图片2', '图片3'];
      for (var i = 0; i < arry.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.src = arry[i];
        await this.loadIMage(image);

        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        let url = canvas.toDataURL(); // 得到图片的base64编码数据
        canvas.toDataURL("image/png");
        baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
        if (baseList.length === arry.length && baseList.length > 0) {
          for (let k = 0; k < baseList.length; k++) {
            imgs.file(
              arry[k].substring(arry[k].lastIndexOf("/") + 1, arry[k].length),

              baseList[k],
              { base64: true }
            );
          }
          zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            FileSaver.saveAs(content, blogTitle + ".zip");
          });
        }
      }
      //如果没有跨越问题直接用图片地址
      // let arry = ['https://api.pwmqr.com/qrcode/create/?url=GK21112500039', 'https://api.pwmqr.com/qrcode/create/?url=GK21112200029'];
      // (arry.forEach(function (url, index) {
      //   setTimeout(() => {//setTimeout是为了防止arry太多导致下载终端机
      //     let link = document.createElement('a')
      //     // 这里是将url转成blob地址，
      //     fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      //       link.href = URL.createObjectURL(blob)
      //       let temp = url.split("?");
      //       temp = temp[0].split("/");
      //       let name = temp[temp.length - 1];//获得图片名字
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click()
      //     })
      //   }, index * 1000)//1000是为了使得浏览器能稳定下载  这个时间可自调建议大于500
      // }))
    },
    //同步二维码
    torefall() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要同步二维码的资产");
        return true;
      }
      this.id = this.selected;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/facility/refreshBatch/${this.id}`, "", "GET")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success(res.msg);
            if (res.msg) {
              setTimeout(() => {
                $utils.url.go(0);
              }, 500);
            }
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    tocheckout(row) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: row.id, isKong: true },
      });
    },
  },
};
</script>
<style scoped></style>
